import { joinClassNames, WithClassnames } from '@vertex-protocol/web-common';

// Bump on every change to verify code updates.
// NEXT_PUBLIC_COMMIT_HASH is set via next.config.mjs env block.
const DEV_VERSION = '0.4.44';
const COMMIT_HASH = process.env.NEXT_PUBLIC_COMMIT_HASH ?? '';

export function AppVersion({ className }: WithClassnames) {
  return (
    <span className={joinClassNames('text-text-tertiary', className)}>
      v{DEV_VERSION}
      {COMMIT_HASH ? `-${COMMIT_HASH}` : ''}
    </span>
  );
}
